import React, { useState } from "react";
import { withStyles } from "@mui/styles";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import MuiDialogContent from "@mui/material/DialogContent";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";
import { categorypage } from "variables/tertiaryBill";
import TextInput from "components/Input/TextInput.js";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

function IndicatorEditionDialog(props) {
  const { closeModal, refetch, setLoading, currentIndicator } = props;

  const [name, setName] = useState(currentIndicator?.name || "Nouvel indicateur");
  const [value, setValue] = useState(currentIndicator?.value || "");

  const handleNameChange = (event) => {
    setName(event.target.value);
    currentIndicator.name = event.target.value;
  };
  const handleValueChange = (event) => {
    setValue(event.target.value);
    currentIndicator.value = event.target.value;
  };

  return (
    <>
      <CustomDialogTitle id="customized-dialog-title" onClose={closeModal}>
        {"Edition de l'indicateur " + name}
      </CustomDialogTitle>
      <DialogContent dividers>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div>
              <TextInput
                isRequired
                inputTitle={categorypage.indicatorname}
                textInput={name}
                handleTextInputChange={handleNameChange}
              />
            </div>
            <div>
              <TextInput
                isRequired
                inputTitle={categorypage.indicatorvalue}
                textInput={value}
                handleTextInputChange={handleValueChange}
              />
            </div>
          </GridItem>
        </GridContainer>
      </DialogContent>
    </>
  );
}
export default IndicatorEditionDialog;
